import { __assign, __values } from "tslib";
import { print, printType, Kind, isSpecifiedScalarType, isIntrospectionType, isScalarType, parse, } from 'graphql';
import { createSchemaDefinition } from './create-schema-definition';
export function printSchemaWithDirectives(schema, _options) {
    var e_1, _a;
    var _b;
    if (_options === void 0) { _options = {}; }
    var typesMap = schema.getTypeMap();
    var result = [getSchemaDefinition(schema)];
    for (var typeName in typesMap) {
        var type = typesMap[typeName];
        var isPredefinedScalar = isScalarType(type) && isSpecifiedScalarType(type);
        var isIntrospection = isIntrospectionType(type);
        if (isPredefinedScalar || isIntrospection) {
            continue;
        }
        // KAMIL: we might want to turn on descriptions in future
        result.push(print((_b = correctType(typeName, typesMap)) === null || _b === void 0 ? void 0 : _b.astNode));
    }
    var directives = schema.getDirectives();
    try {
        for (var directives_1 = __values(directives), directives_1_1 = directives_1.next(); !directives_1_1.done; directives_1_1 = directives_1.next()) {
            var directive = directives_1_1.value;
            if (directive.astNode) {
                result.push(print(directive.astNode));
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (directives_1_1 && !directives_1_1.done && (_a = directives_1.return)) _a.call(directives_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result.join('\n');
}
function extendDefinition(type) {
    switch (type.astNode.kind) {
        case Kind.OBJECT_TYPE_DEFINITION:
            return __assign(__assign({}, type.astNode), { fields: type.astNode.fields.concat(type.extensionASTNodes.reduce(function (fields, node) { return fields.concat(node.fields); }, [])) });
        case Kind.INPUT_OBJECT_TYPE_DEFINITION:
            return __assign(__assign({}, type.astNode), { fields: type.astNode.fields.concat(type.extensionASTNodes.reduce(function (fields, node) { return fields.concat(node.fields); }, [])) });
        default:
            return type.astNode;
    }
}
function correctType(typeName, typesMap) {
    var e_2, _a, e_3, _b;
    var _c;
    var type = typesMap[typeName];
    type.name = typeName.toString();
    if (type.astNode && type.extensionASTNodes) {
        type.astNode = type.extensionASTNodes ? extendDefinition(type) : type.astNode;
    }
    var doc = parse(printType(type));
    var fixedAstNode = doc.definitions[0];
    var originalAstNode = type === null || type === void 0 ? void 0 : type.astNode;
    if (originalAstNode) {
        fixedAstNode.directives = originalAstNode === null || originalAstNode === void 0 ? void 0 : originalAstNode.directives;
        if (fixedAstNode && 'fields' in fixedAstNode && originalAstNode && 'fields' in originalAstNode) {
            var _loop_1 = function (fieldDefinitionNode) {
                var e_4, _a;
                var originalFieldDefinitionNode = originalAstNode.fields.find(function (field) { return field.name.value === fieldDefinitionNode.name.value; });
                fieldDefinitionNode.directives = originalFieldDefinitionNode === null || originalFieldDefinitionNode === void 0 ? void 0 : originalFieldDefinitionNode.directives;
                if (fieldDefinitionNode &&
                    'arguments' in fieldDefinitionNode &&
                    originalFieldDefinitionNode &&
                    'arguments' in originalFieldDefinitionNode) {
                    var _loop_3 = function (argument) {
                        var originalArgumentNode = (_c = originalFieldDefinitionNode.arguments) === null || _c === void 0 ? void 0 : _c.find(function (arg) { return arg.name.value === argument.name.value; });
                        argument.directives = originalArgumentNode.directives;
                    };
                    try {
                        for (var _b = (e_4 = void 0, __values(fieldDefinitionNode.arguments)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var argument = _c.value;
                            _loop_3(argument);
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            };
            try {
                for (var _d = __values(fixedAstNode.fields), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var fieldDefinitionNode = _e.value;
                    _loop_1(fieldDefinitionNode);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        else if (fixedAstNode && 'values' in fixedAstNode && originalAstNode && 'values' in originalAstNode) {
            var _loop_2 = function (valueDefinitionNode) {
                var originalValueDefinitionNode = originalAstNode.values.find(function (valueNode) { return valueNode.name.value === valueDefinitionNode.name.value; });
                valueDefinitionNode.directives = originalValueDefinitionNode === null || originalValueDefinitionNode === void 0 ? void 0 : originalValueDefinitionNode.directives;
            };
            try {
                for (var _f = __values(fixedAstNode.values), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var valueDefinitionNode = _g.value;
                    _loop_2(valueDefinitionNode);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    type.astNode = fixedAstNode;
    return type;
}
function getSchemaDefinition(schema) {
    if (!Object.getOwnPropertyDescriptor(schema, 'astNode').get && schema.astNode) {
        return print(schema.astNode);
    }
    else {
        return createSchemaDefinition({
            query: schema.getQueryType(),
            mutation: schema.getMutationType(),
            subscription: schema.getSubscriptionType(),
        });
    }
}
//# sourceMappingURL=print-schema-with-directives.js.map